// The signed-in dentist's own identity.
//
// `me` is served from the profile the gate already read for this request, so it
// costs no extra downstream round trip — cheap enough for the sidebar to ask
// for on its own rather than being threaded down from App.

import React from 'react';
import { bffQuery } from '../lib/bffClient.js';

export const ME_QUERY = `
  query Me {
    me { id fullName medicalCode specialty bio isDentist isOnboarded }
  }
`;

export function useMe() {
  const [me, setMe] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [nonce, setNonce] = React.useState(0);

  React.useEffect(() => {
    let alive = true;
    bffQuery(ME_QUERY)
      .then((data) => {
        if (!alive) return;
        setMe(data?.me || null);
        setError(null);
      })
      .catch((err) => {
        if (!alive) return;
        console.error('[useMe] failed:', err?.message);
        setError(err);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [nonce]);

  return { me, loading, error, reload: () => setNonce((n) => n + 1) };
}

export default useMe;
